/*========================================================================
 * $Id$
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/
 
define(["underscore", "backbone"], function(_, Backbone) {
 
 /**
  * use this class to compute a sequence of task once an event 
  * is received. 
  * 
  * Example: 
  * <code>
    var seq = new TaskSeqeuence(model, "computed aborted");
    
    seq.start(function() {
      stop();
      trace("(1) change query.");
      model.input.set("query", "tenantid:COO.6505.100.1.777143#sgbs.faba5.com test");
      
    })
    .then(function(){
      trace("(2) test status query and change count to two.");
      // assert expectations
      model.input.set("count", 2);
    })
    .done(function() {
      trace("(3) test count three, finish test.");
      start(); // finished the test.
    });
  * </code>
  *  
  */
 function TaskSequence(source, events) {
    this.source = source;
    this.events = events;
    this._executed = false;
    this._tasks = [];
    this._currentTaskID = 0;
    this._allTasksRegistered = false;
    this._run();
  }
  
  _.extend(TaskSequence.prototype, Backbone.Events, {
    
    _run: function() {
      if (this._currentTaskID >= this._tasks.length) {
        // this is finished now
        if (this._allTasksRegistered) {
          this._finished = true;
          return;
        }
        this.once("newtask", this._run, this);
      }
      else {
        var task = this._tasks[this._currentTaskID];
        this._currentTaskID++;
        this.source.once(this.events, this._run, this);
        if (task) {
          task();
        }// wait for event and perform the next task.
      }
    },
    
    then: function(task, ctx) {
      if (ctx) {
        task = function() {return task.apply(ctx, arguments);};
      }
      this._tasks.push(task);
      // we have a new task
      this.trigger("newtask");
      return this;
    },
    
    done: function(task, ctx) {
      if (task) {
        this.then(task, ctx);
      }
      this._allTasksRegistered = true;
      return this;
    },
    
    start: function(task, ctx) {
      return this.then(task, ctx);
    }
    
  });
  
  return TaskSequence;
});